// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { hideElementOnPrint, xParserOptions } from "@conklin/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import parse from "html-react-parser";
import React, { FC } from "react";

interface OwnProps {
    isExpandedByDefault?: boolean;
}
export interface ProductDetailsVimeoStyles {
    wrapper?: AccordionSectionPresentationProps;
    videosContainer?: GridContainerProps;
}

export const productDetailsVimeoStyles: ProductDetailsVimeoStyles = {
    wrapper: {
        headerProps: {
            css: hideElementOnPrint,
        },
        panelProps: {
            css: hideElementOnPrint,
        },
    },
};

const styles = productDetailsVimeoStyles;

type Props = OwnProps & HasProductContext;

const ProductDetailsVimeo: FC<Props> = ({ productContext, isExpandedByDefault }) => {
    const video = productContext?.product.properties?.vimeoEmbeds;

    if (!video) {
        return null;
    }

    return (
        <ManagedAccordionSection title={translate("Video")} initialExpanded={isExpandedByDefault} {...styles.wrapper}>
            <StyledWrapper {...styles.videosContainer}>
                {parse(transformContentHtml(video), xParserOptions)}
            </StyledWrapper>
        </ManagedAccordionSection>
    );
};

export default withProductContext(ProductDetailsVimeo);
